export const LOCAL_STORAGE_KEYS = {
  SLACK: 'slack'
};

const useLocalStorageFF = (key: (typeof LOCAL_STORAGE_KEYS)[keyof typeof LOCAL_STORAGE_KEYS]) =>
  localStorage.getItem(key) === 'true';

export default useLocalStorageFF;
